import React, { Component } from 'react'
import { object, func } from 'prop-types'
import { connect } from 'react-redux'
import axios from 'axios'
import { toastr } from 'react-redux-toastr'

// utils
import config from '../config'
import { getAuthToken } from '../utils/sessionStorage'

// actions
import { updateVideo } from '../actions'

// components
import ConfirmModal from './modals/ConfirmModal'

class ButtonPlayPause extends Component {
  constructor () {
    super()
    this.state = {
      showConfirmModal: false,
      action: ''
    }

    this.openConfirmModal = this.openConfirmModal.bind(this)
    this.closeConfirmModal = this.closeConfirmModal.bind(this)
    this.changeVideoStatus = this.changeVideoStatus.bind(this)
  }
  openConfirmModal (action) {
    this.setState({
      showConfirmModal: true,
      action
    })
  }
  closeConfirmModal () {
    this.setState({
      showConfirmModal: false
    })
  }
  changeVideoStatus (reason) {
    let { video, updateVideo } = this.props
    let { action } = this.state
    let url = `${config.url}/campaigns/${video.campaign_id}/videos/${video.id}/status`
    axios({
      method: 'POST',
      url: url,
      headers: {'X-User-Token': getAuthToken()},
      data: {
        reason,
        name: action
      }
    })
      .then((res) => {
        let updatedVideo = res.data
        updateVideo(video.campaign_id, updatedVideo)
        toastr.success('Video atualizado com sucesso!')
      })
      .catch((err) => {
        toastr.error('Ocorreu um erro. Tente novamente.')
      })
    this.setState({
      showConfirmModal: false
    })
  }
  render () {
    const { video } = this.props
    if (video.status === undefined || video.status.name === undefined) {
      return false
    }
    let button
    let videoConfig = {
      playing: {
        text: 'pausar',
        icon: 'pause',
        modalActionText: 'paused',
        btnStyle: 'muted'
      },
      paused: {
        text: 'Pausado',
        icon: 'play',
        modalActionText: 'playing',
        btnStyle: 'success'
      }
    }
    let canBePlayed = true
    let motive = ''
    if (!video.approved) {
      canBePlayed = false
      motive = 'O video só pode ser ativado após aprovado.'
    }

    let modalAction = videoConfig[video.status.name]['modalActionText']
    let buttonIcon = videoConfig[video.status.name]['icon']
    // let statusText = videoConfig[video.status.name]['text']
    let btnStyle = videoConfig[video.status.name]['btnStyle']

    button = (
      <button
        className={`btn btn-sm btn-${btnStyle}`}
        onClick={() => { this.openConfirmModal(modalAction) }}
        disabled={!canBePlayed}
        title={motive}
      >
        <span
          className={`glyphicon glyphicon-${buttonIcon}`}
          aria-hidden='true'
        />
      </button>
    )

    return (
      <div className='btn-group mr10'>
        {button}
        <ConfirmModal
          show={this.state.showConfirmModal}
          action={this.state.action}
          onClickNo={this.closeConfirmModal}
          onClickYes={this.changeVideoStatus}
        />
      </div>
    )
  }
}

ButtonPlayPause.propTypes = {
  video: object,
  updateVideo: func
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateVideo: (campaignId, video) => {
      dispatch(updateVideo(campaignId, video))
    }
  }
}

export default connect(null, mapDispatchToProps)(ButtonPlayPause)



// WEBPACK FOOTER //
// ./src/components/ButtonPlayPause.js